export default __webpack_public_path__ + "static/media/Licence.1085a1c3.jpg";